import script from "./AutoEnrolment-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"
export * from "./AutoEnrolment-Questionnaire-Main.vue?vue&type=script&setup=true&lang=js"

import "./AutoEnrolment-Questionnaire-Main.vue?vue&type=style&index=0&id=c6d615ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6d615ac"]])

export default __exports__